import { FC } from 'react';
import ProcessedDossiersIcon from 'images/processed-dossiers.svg';

const ProcessedDossiers: FC = () => {
  return <img src={ProcessedDossiersIcon} alt="processed-dossiers-icon" />;
};
export default ProcessedDossiers;
